/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '../../styles';
import moment from 'moment';
import { TIMESTAMP_FORMAT_WITH_YEAR } from '../../../shared/utils/dates';
import Localized from '../../../shared/components/Localized';

const Wrapper= styled.div`
  ${styles.fonts.footerLabel}
  margin-top: 0.75rem;
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
  }
`;

/**
 * This component allows you to render the createdAt and lastModified timestamp.
 */
class FooterTimestamp extends React.Component {

  static propTypes = {
    createdTime: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    lastModifiedTime: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    region: PropTypes.string,
    missingTranslations: PropTypes.func
  };

  render() {
    const { createdTime, lastModifiedTime, region, missingTranslations, className } = this.props;
    return (
      <Wrapper className={className}>
        { createdTime && 
          <span>
            <Localized
              modelName='generalMessage'
              modelKey= 'posted'
              modelAttribute='header'
              missingTranslations={missingTranslations} 
            />&nbsp;
            { moment.tz(createdTime , region).format(TIMESTAMP_FORMAT_WITH_YEAR) }
            {lastModifiedTime && <span>&nbsp;&#183;&nbsp;</span>}
          </span>
        }
        { lastModifiedTime &&
          <span>
            <Localized
              modelName='generalMessage'
              modelKey= 'lastModified'
              modelAttribute='header'
              missingTranslations={missingTranslations} 
            />&nbsp;
            { moment.tz(lastModifiedTime , region).format(TIMESTAMP_FORMAT_WITH_YEAR) }
          </span>
        }
      </Wrapper>
    );
  }

}

export default FooterTimestamp;